__turbopack_context__.v({
  "editMode": "RichTextWithTable-module-scss-module__S6twaq__editMode",
  "hasHeaderRow": "RichTextWithTable-module-scss-module__S6twaq__hasHeaderRow",
  "hasNoHeaderRow": "RichTextWithTable-module-scss-module__S6twaq__hasNoHeaderRow",
  "headerRow": "RichTextWithTable-module-scss-module__S6twaq__headerRow",
  "publishedView": "RichTextWithTable-module-scss-module__S6twaq__publishedView",
  "richTextContent": "RichTextWithTable-module-scss-module__S6twaq__richTextContent",
});
